import React, { useContext, useEffect, useState } from 'react';
import { PageContent, PageSection } from '../../../common/styles/page';
import Tabs from 'common/components/Tabs';
import AnalyticsOverview from './AnalyticsOverview';
import AnalyticsPillars from './AnalyticsPillars';
import AnalyticsInsights from './AnalyticsInsights';
import AnalyticsFeedback from './AnalyticsFeedback';
import { useSearchParams } from 'react-router-dom';
import AnalyticsDemographics from './AnalyticsDemographics';
import AnalyticsResources from './AnalyticsResources';
import { useSelector } from 'react-redux';
import { getSelectedAssessmentPeriod } from 'common/selectors/auth';
import { ASSESSMENT_PERIOD_CLOSED } from 'areas/assessment-schedule/constants';
import { TopBarContext } from 'common/layouts/AuthLayout/TopBarContext';
import TopBarControls from 'common/layouts/AuthLayout/TopBarAssessmentPeriod';
import LandingPage from 'common/layouts/AuthLayout/LandingPage';


const tabs = ['Overview', 'Questions', 'Feedback', 'Insights', 'Demographics', 'Resources'];

const DataAnalytics = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchParams] = useSearchParams();

  const { setTopBarContent } = useContext(TopBarContext);

  const selectedAssessmentPeriod = useSelector(getSelectedAssessmentPeriod);

  useEffect(() => {
    setTopBarContent(<TopBarControls />);
    return () => setTopBarContent(null);
  }, [setTopBarContent, selectedAssessmentPeriod]);

  const tab = Number(searchParams.get('tab'));
  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);


  if (selectedAssessmentPeriod?.status !== ASSESSMENT_PERIOD_CLOSED) {
    return (
      <PageContent>
        <PageSection>
          <LandingPage
            title="Assessment In Progress"
            subtitle="The selected assessment period is still in progress. Data analytics for the current period will be available once the period is closed. Feel free to select a different assessment period to view analytics."
            buttonLabel=""
            navDestination="#"
          />
        </PageSection>
      </PageContent>
    );
  }


  return (
    <PageContent data-testid="admin-analytics-page">
      <Tabs
        data-testid="admin-analytics-nav"
        options={tabs}
        onSelect={(item: React.SetStateAction<number>) => setSelectedTab(item)}
        selected={selectedTab}
        borderbottom
      />

      {tabs[selectedTab] === 'Overview' && (
        <PageSection padright data-testid="admin-analytics-content">
          <AnalyticsOverview />
        </PageSection>
      )}
      {tabs[selectedTab] === 'Questions' && (
        <PageSection data-testid="admin-analytics-content">
          <AnalyticsPillars />
        </PageSection>
      )}

      {tabs[selectedTab] === 'Feedback' && (
        <PageSection data-testid="admin-analytics-content">
          <AnalyticsFeedback />
        </PageSection>
      )}
      {tabs[selectedTab] === 'Insights' && (
        <PageSection data-testid="admin-analytics-content">
          <AnalyticsInsights />
        </PageSection>
      )}
      {tabs[selectedTab] === 'Demographics' && (
        <PageSection data-testid="admin-analytics-content">
          <AnalyticsDemographics />
        </PageSection>
      )}
      {tabs[selectedTab] === 'Resources' && (
        <PageSection data-testid="admin-analytics-content">
          <AnalyticsResources />
        </PageSection>
      )}
    </PageContent>
  );
};
export default DataAnalytics;
